module.exports = __webpack_public_path__ + "img/intro_to_gamemaker_splash.9907b6be.jpg";